export const resizableStyles = {
    '.react-resizable:has(.react-resizable-handle:hover) .react-resizable-handle-se, .react-resizable:has(.react-resizable-handle:active) .react-resizable-handle-se, .react-resizable:has(div[data-boardid="0"] > div:last-child > div:last-child:hover) .react-resizable-handle-se, .react-resizable-handle-se:hover, .react-resizable-handle-se:active':
        {
            backgroundImage: 'url(/assets/images/icons/scale-board.svg)',
            backgroundSize: '85%',
            backgroundColor: 'black',
            zIndex: 101,
            borderBottomRightRadius: '12px',
        },

    '.react-resizable': {
        position: 'relative',
        aspectRatio: 1,
    },
    '.react-resizable-handle': {
        cursor: 'ew-resize',
        position: 'absolute',
        width: 'min(6%, 24px)',
        height: 'min(6%, 24px)',
        backgroundRepeat: 'no-repeat',
        zIndex: 100,
    },
    '.react-resizable-handle-sw': {
        bottom: 0,
        left: 0,
        cursor: 'nesw-resize',
        transform: 'rotate(90deg)',
    },
    '.react-resizable-handle-se': {
        bottom: 0,
        right: 0,
        cursor: 'nwse-resize',
    },
    '.react-resizable-handle-nw': {
        top: 0,
        left: 0,
        cursor: 'nwse-resize',
        transform: 'rotate(180deg)',
    },
    '.react-resizable-handle-ne': {
        top: 0,
        right: 0,
        cursor: 'nesw-resize',
        transform: 'rotate(270deg)',
    },
    '.react-resizable-handle-w': {
        width: '7px',
        height: 'calc(100% - 14px)',
        left: 0,
        top: 7,
        cursor: 'ew-resize',
    },
    '.react-resizable-handle-e': {
        width: '7px',
        height: 'calc(100% - 14px)',
        right: 0,
        top: 7,
        cursor: 'ew-resize',
    },
    '.react-resizable-handle-n': {
        width: 'calc(100% - 14px)',
        height: '7px',
        left: 7,
        top: 0,
        cursor: 'ns-resize',
    },
    '.react-resizable-handle-s': {
        width: 'calc(100% - 14px)',
        height: '7px',
        left: 7,
        bottom: 0,
        cursor: 'ns-resize',
    },
}
